module.exports = __webpack_public_path__ + "static/media/calendar-check.b0920542.svg";